import { motion } from "framer-motion";
import { Toon } from "@/components/Toon";

const EASE = [0.76, 0, 0.24, 1];

const CHAPTERS = [
  {
    n: "01",
    title: "The Promise",
    body: "It's simple — when in need: CallMe📲Gerard. One call puts 19+ years of commercial problem-solving on your side of the table. No runaround, no fluff — just answers.",
  },
  {
    n: "02",
    title: "The Experience",
    body: "19+ years in sales, business development, and commercial B2B engagement — from employer group health insurance and energy procurement to business funding, real estate capital, and the negotiating table.",
  },
  {
    n: "03",
    title: "The Approach",
    body: "Insurance. Energy. Finance. Payments. I start with your numbers, connect you with the right tools and partners, and stay hands-on until the savings and terms are real.",
  },
  {
    n: "04",
    title: "The Outcome",
    body: "Lower benefit costs without cutting coverage. Cheaper, cleaner energy. Funding that fits your next move. Deals closed on your terms. That's the call working for you.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="about"
      data-testid="manifesto-section"
      className="mx-auto max-w-[90rem] px-6 py-28 md:px-12 md:py-40"
    >
      <div className="mb-6 flex items-center gap-4">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="text-xs uppercase tracking-[0.35em] text-steel"
        >
          About
        </motion.p>
        <Toon testId="manifesto-toon" variant="float" />
      </div>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
        className="mb-20 max-w-3xl font-serif text-4xl leading-tight tracking-tight text-fog md:text-6xl"
      >
        Solid principles,{" "}
        <span className="italic text-steel">kept for 19+ years</span>
      </motion.h2>

      <div>
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            data-testid={`chapter-${c.n}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.05 }}
            className="grid grid-cols-1 gap-6 border-t border-white/10 py-14 md:grid-cols-12 md:py-16"
          >
            <div className="md:col-span-4">
              <span className="font-sans font-bold text-white text-[3.5rem] leading-none md:text-[4.5rem]">
                {c.n.replace(/^0+/, "")}
              </span>
            </div>
            <div
              className={`md:col-span-7 ${
                i % 2 ? "md:col-start-6" : "md:col-start-5"
              }`}
            >
              <h3 className="font-serif text-3xl tracking-tight text-fog md:text-4xl">
                {c.title}
              </h3>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-ash md:text-lg">
                {c.body}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
